import { ArrowRight, Check, GitBranch, ShieldCheck } from "lucide-react";
import { FadeIn } from "../components/FadeIn";
import { methodSteps } from "../content/portfolio";

export function MethodSection() {
  return (
    <section id="method" aria-labelledby="method-heading" className="method-section">
      <div className="method-topline">
        <span className="method-topline-status"><i aria-hidden="true" /> FAIL-CLOSED BY DEFAULT</span>
      </div>
      <div className="method-heading-row">
        <FadeIn as="h2" id="method-heading" y={34} className="section-heading section-heading--light">
          工作方法
        </FadeIn>
        <FadeIn as="p" delay={0.1} className="method-lede">
          测试不是把结果交给别人猜，而是把风险、执行、证据和结论连成一条可解释的路径。
        </FadeIn>
      </div>

      <ol className="method-flow" aria-label="工作方法四步链路">
        {methodSteps.map((step, index) => (
          <FadeIn as="li" key={step.number} delay={index * 0.07} className="method-step">
            <div className="method-step-index">
              <span>{step.number}</span>
              {index < methodSteps.length - 1 && <ArrowRight aria-hidden="true" />}
            </div>
            <h3>{step.title}</h3>
            <p>{step.text}</p>
          </FadeIn>
        ))}
      </ol>

      <FadeIn className="method-proof-strip" delay={0.22}>
        <div><GitBranch aria-hidden="true" /><span>可重复执行</span></div>
        <div><ShieldCheck aria-hidden="true" /><span>边界可审计</span></div>
        <div><Check aria-hidden="true" /><span>结论可发布</span></div>
      </FadeIn>
    </section>
  );
}
